import React, { useState } from 'react';
import { BuildingIcon, CalendarIcon, PercentIcon, FileTextIcon } from 'lucide-react';
export function ProjectDetailsStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    projectName: initialData.projectName || '',
    projectDescription: initialData.projectDescription || '',
    projectLocation: initialData.projectLocation || '',
    projectArea: initialData.projectArea || '',
    projectType: initialData.projectType || 'agriculture',
    salesProbability: initialData.salesProbability || '50',
    expectedClosingDate: initialData.expectedClosingDate || '',
    notes: initialData.notes || '',
    ...initialData
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleBlur = () => {
    onUpdate(formData);
  };
  return <div className="space-y-6" data-id="element-4449" data-mp="3lcxd6nguv057">
      <div className="text-white text-xl font-medium mb-6" data-id="element-4450" data-mp="3ldyz5mzet71p">Project Details</div>
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4451" data-mp="1r3pn2i798bbo">
        <div className="flex items-center mb-4" data-id="element-4452" data-mp="1m5o3lw5x29zo">
          <FileTextIcon size={20} className="text-blue-400 mr-2" data-id="element-4453" data-mp="1m6z3hkw8qxli" />
          <h3 className="text-white font-medium" data-id="element-4454" data-mp="1zx2k9wccpz3k">Basic Information</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4455" data-mp="1v5klnexswalr">
          <div data-id="element-4456" data-mp="1v3zrhqfeetof">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4457" data-mp="29v07qhmdzrv4">
              Project Name
            </label>
            <input type="text" name="projectName" value={formData.projectName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter project name" data-id="element-4458" data-mp="24w5q3j05o9cl" />
          </div>
          <div data-id="element-4459" data-mp="ogvxjyd883q3">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4460" data-mp="oifc9kj8i6pr">
              Project Location
            </label>
            <input type="text" name="projectLocation" value={formData.projectLocation} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter location (city, country)" data-id="element-4461" data-mp="khvd6bf3ot0z" />
          </div>
          <div className="md:col-span-2" data-id="element-4462" data-mp="2yhtcpk71sqvb">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4463" data-mp="2yiuq3vbjdpg7">
              Project Description
            </label>
            <textarea name="projectDescription" value={formData.projectDescription} onChange={handleChange} onBlur={handleBlur} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Briefly describe the project" data-id="element-4464" data-mp="32jelouggol08"></textarea>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4465" data-mp="3m8yn3ju7yqy8">
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4466" data-mp="3q8r1id6anrbi">
          <div className="flex items-center mb-4" data-id="element-4467" data-mp="1elxbkwq9hht3">
            <BuildingIcon size={20} className="text-blue-400 mr-2" data-id="element-4468" data-mp="1emoylj5sm77r" />
            <h3 className="text-white font-medium" data-id="element-4469" data-mp="1ajsgruo2uf4v">Project Specifications</h3>
          </div>
          <div className="space-y-4" data-id="element-4470" data-mp="15kpbqa83k8ww">
            <div data-id="element-4471" data-mp="15lr01ge4irwk">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4472" data-mp="15nbk2c2tasg6">
                Project Area (hectares)
              </label>
              <input type="number" name="projectArea" value={formData.projectArea} onChange={handleChange} onBlur={handleBlur} min="0" step="0.01" className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter area in hectares" data-id="element-4473" data-mp="1y9mwcjzs6hst" />
            </div>
            <div data-id="element-4474" data-mp="1jkgwqux16pke">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4475" data-mp="1jiw1t46t14m0">
                Project Type
              </label>
              <select name="projectType" value={formData.projectType} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4476" data-mp="2c9nv9twhjf5n">
                <option value="agriculture" data-id="element-4477" data-mp="25rjd8cjuf2a3">Agriculture</option>
                <option value="greenhouse" data-id="element-4478" data-mp="2ar5serj8eslj">Greenhouse</option>
                <option value="golf" data-id="element-4479" data-mp="2apcin3dbns9b">Golf Course</option>
                <option value="sports" data-id="element-4480" data-mp="2ygqehjaom5z1">Sports Fields</option>
                <option value="landscaping" data-id="element-4481" data-mp="337q7idgok3w9">Landscaping</option>
                <option value="other" data-id="element-4482" data-mp="339b0hyncjes0">Other</option>
              </select>
            </div>
            <div data-id="element-4483" data-mp="rrg7vh67ezff">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4484" data-mp="rqwtgafrit65">Notes</label>
              <textarea name="notes" value={formData.notes} onChange={handleChange} onBlur={handleBlur} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Additional notes about the project" data-id="element-4485" data-mp="msv8tl2oulsk"></textarea>
            </div>
          </div>
        </div>
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4486" data-mp="3vbvw6d40j0v">
          <div className="flex items-center mb-4" data-id="element-4487" data-mp="hujvh0d6pt5l">
            <CalendarIcon size={20} className="text-blue-400 mr-2" data-id="element-4488" data-mp="hw4t4yusps7o" />
            <h3 className="text-white font-medium" data-id="element-4489" data-mp="cv7ciqpfp68a">Sales Information</h3>
          </div>
          <div className="space-y-4" data-id="element-4490" data-mp="1t97a3v0t4jsd">
            <div data-id="element-4491" data-mp="1t85lsous60sp">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4492" data-mp="1tbtgvsfviv9j">
                Sales Probability (%)
              </label>
              <div className="flex items-center" data-id="element-4493" data-mp="lx7syw6kn7lo">
                <input type="range" name="salesProbability" min="0" max="100" step="5" value={formData.salesProbability} onChange={handleChange} onBlur={handleBlur} className="w-full h-2 bg-slate-700 rounded-lg appearance-none cursor-pointer" data-id="element-4494" data-mp="lwpqvix89z5u" />
                <span className="ml-3 text-white font-medium min-w-[3rem] text-right" data-id="element-4495" data-mp="zx0gkimsx7pf">
                  {formData.salesProbability}%
                </span>
              </div>
              <div className="flex justify-between text-xs text-blue-400 mt-1" data-id="element-4496" data-mp="34n73ypai2rd">
                <span data-id="element-4497" data-mp="78uvfuru5gp2">Low</span>
                <span data-id="element-4498" data-mp="75z26jqxng6y">Medium</span>
                <span data-id="element-4499" data-mp="c765o6m1lt7t">High</span>
              </div>
            </div>
            <div data-id="element-4500" data-mp="gy4r1klw1hhx">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4501" data-mp="gyoa54n9ybxj">
                Expected Closing Date
              </label>
              <div className="relative" data-id="element-4502" data-mp="3fnda4fca7uhn">
                <input type="date" name="expectedClosingDate" value={formData.expectedClosingDate} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-4503" data-mp="3fmaj87eyls1q" />
                <CalendarIcon size={18} className="absolute right-3 top-3 text-blue-400 pointer-events-none" data-id="element-4504" data-mp="382j9b5crcsyy" />
              </div>
            </div>
            <div className="bg-blue-900/30 rounded-lg p-4 mt-4" data-id="element-4505" data-mp="2z4pb1ovfnp95">
              <div className="flex items-start" data-id="element-4506" data-mp="2u4ujrk7qwxnk">
                <PercentIcon size={18} className="text-blue-400 mr-2 mt-0.5" data-id="element-4507" data-mp="2u5mg4x962zew" />
                <div data-id="element-4508" data-mp="2pdun8g2jghll">
                  <h4 className="text-white text-sm font-medium mb-1" data-id="element-4509" data-mp="2pdcmp78ufh7v">
                    Sales Probability Guide
                  </h4>
                  <ul className="text-xs text-blue-300 space-y-1 list-disc pl-4" data-id="element-4510" data-mp="2kcoskcpbik9f">
                    <li data-id="element-4511" data-mp="2fdvfumhuuxab">0-25%: Initial contact, exploring options</li>
                    <li data-id="element-4512" data-mp="2bd1sbu8brkhy">26-50%: Engaged in discussions, some interest shown</li>
                    <li data-id="element-4513" data-mp="26f0835z5xf4w">51-75%: Serious interest, negotiating details</li>
                    <li data-id="element-4514" data-mp="3ubyah7wppu5e">
                      76-100%: Highly likely to close, finalizing agreement
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}